export default __webpack_public_path__ + "static/media/upWhite.def62dc6.svg";